import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";

import { PanelHeader, CardCategory, Stats } from "components";

import {
  chartsLine1,
  chartsLine2,
  chartsBar1,
  chartsBar2
} from "variables/charts";

import { ResponsiveBar } from '@nivo/bar'

const MyResponsiveBar = ({ data /* see data tab */ }) => (
  <ResponsiveBar
      data={data}
      keys={[ 'date_month', 'total_billed' ]}
      indexBy="date_month"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      colors={{ scheme: 'nivo' }}
      defs={[
          {
              id: 'dots',
              type: 'patternDots',
              background: 'inherit',
              color: '#38bcb2',
              size: 4,
              padding: 1,
              stagger: true
          },
          {
              id: 'lines',
              type: 'patternLines',
              background: 'inherit',
              color: '#eed312',
              rotation: -45,
              lineWidth: 6,
              spacing: 10
          }
      ]}
      // fill={[
      //     {
      //         match: {
      //             id: 'fries'
      //         },
      //         id: 'dots'
      //     },
      //     {
      //         match: {
      //             id: 'sandwich'
      //         },
      //         id: 'lines'
      //     }
      // ]}
      borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'date_month',
          legendPosition: 'middle',
          legendOffset: 32
      }}
      axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'total_billed',
          legendPosition: 'middle',
          legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
      legends={[
          {
              dataFrom: 'keys',
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: 'left-to-right',
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                  {
                      on: 'hover',
                      style: {
                          itemOpacity: 1
                      }
                  }
              ]
          }
      ]}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
  />
);

const dataTest = [
  {
    "country": "AD",
    "hot dog": 92,
    "hot dogColor": "hsl(159, 70%, 50%)",
    "burger": 89,
    "burgerColor": "hsl(228, 70%, 50%)",
    "sandwich": 70,
    "sandwichColor": "hsl(271, 70%, 50%)",
    "kebab": 189,
    "kebabColor": "hsl(189, 70%, 50%)",
    "fries": 137,
    "friesColor": "hsl(190, 70%, 50%)",
    "donut": 29,
    "donutColor": "hsl(287, 70%, 50%)"
  },
  {
    "country": "AE",
    "hot dog": 141,
    "hot dogColor": "hsl(336, 70%, 50%)",
    "burger": 162,
    "burgerColor": "hsl(234, 70%, 50%)",
    "sandwich": 196,
    "sandwichColor": "hsl(69, 70%, 50%)",
    "kebab": 138,
    "kebabColor": "hsl(318, 70%, 50%)",
    "fries": 55,
    "friesColor": "hsl(66, 70%, 50%)",
    "donut": 5,
    "donutColor": "hsl(350, 70%, 50%)"
  },
  {
    "country": "AF",
    "hot dog": 83,
    "hot dogColor": "hsl(60, 70%, 50%)",
    "burger": 174,
    "burgerColor": "hsl(100, 70%, 50%)",
    "sandwich": 56,
    "sandwichColor": "hsl(201, 70%, 50%)",
    "kebab": 64,
    "kebabColor": "hsl(100, 70%, 50%)",
    "fries": 46,
    "friesColor": "hsl(191, 70%, 50%)",
    "donut": 179,
    "donutColor": "hsl(113, 70%, 50%)"
  },
  {
    "country": "AG",
    "hot dog": 58,
    "hot dogColor": "hsl(269, 70%, 50%)",
    "burger": 199,
    "burgerColor": "hsl(295, 70%, 50%)",
    "sandwich": 32,
    "sandwichColor": "hsl(187, 70%, 50%)",
    "kebab": 142,
    "kebabColor": "hsl(250, 70%, 50%)",
    "fries": 43,
    "friesColor": "hsl(71, 70%, 50%)",
    "donut": 111,
    "donutColor": "hsl(281, 70%, 50%)"
  },
  {
    "country": "AI",
    "hot dog": 33,
    "hot dogColor": "hsl(133, 70%, 50%)",
    "burger": 142,
    "burgerColor": "hsl(186, 70%, 50%)",
    "sandwich": 85,
    "sandwichColor": "hsl(319, 70%, 50%)",
    "kebab": 146,
    "kebabColor": "hsl(177, 70%, 50%)",
    "fries": 60,
    "friesColor": "hsl(163, 70%, 50%)",
    "donut": 39,
    "donutColor": "hsl(217, 70%, 50%)"
  },
  {
    "country": "AL",
    "hot dog": 132,
    "hot dogColor": "hsl(218, 70%, 50%)",
    "burger": 21,
    "burgerColor": "hsl(273, 70%, 50%)",
    "sandwich": 130,
    "sandwichColor": "hsl(158, 70%, 50%)",
    "kebab": 91,
    "kebabColor": "hsl(80, 70%, 50%)",
    "fries": 74,
    "friesColor": "hsl(329, 70%, 50%)",
    "donut": 38,
    "donutColor": "hsl(325, 70%, 50%)"
  },
  {
    "country": "AM",
    "hot dog": 176,
    "hot dogColor": "hsl(234, 70%, 50%)",
    "burger": 116,
    "burgerColor": "hsl(275, 70%, 50%)",
    "sandwich": 160,
    "sandwichColor": "hsl(94, 70%, 50%)",
    "kebab": 40,
    "kebabColor": "hsl(151, 70%, 50%)",
    "fries": 199,
    "friesColor": "hsl(59, 70%, 50%)",
    "donut": 160,
    "donutColor": "hsl(57, 70%, 50%)"
  }
];
const colSizesCustomersSummup = { xs: 3, className: "text-center" };
const colSizesCustomersInternetSummup = { xs: 6, className: "text-center" };

const formatterCurrency = new Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR'
});
const formatterNumber = new Intl.NumberFormat("de-DE", {
  style: 'decimal'
});

class Pegasus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //xs, sm, md, lg, xl
      chartSizes: {
        small: {
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3,
          xl: 3
        },
        medium: {
          xs: 12,
          sm: 6
        }
      },
      panelSizeBig: 3,
      billingBigData: []
    };
    this.buildGroupedBillingChart = this.buildGroupedBillingChart.bind(this);
    this.buildActiveCustomersChart = this.buildActiveCustomersChart.bind(this);
    this.buildBillReturningCustomersChart = this.buildBillReturningCustomersChart.bind(this);
    this.buildPaidBillsChart = this.buildPaidBillsChart.bind(this);
    this.buildBillsBigDataChart = this.buildBillsBigDataChart.bind(this);
    this.prepareDataForBillsBigDataChart = this.prepareDataForBillsBigDataChart.bind(this);
    this.predictNextMonthBilling = this.predictNextMonthBilling.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  componentDidMount() {
    if (this.props.mainState.user.name !== "Adrian-nadunet" && this.props.mainState.user.name !== "Ruben") {
      this.redirectTo("/dashboard");
    }
    this.props.app.getBillingData();
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    let currentBigData = this.state.billingBigData;
    let bigDataUpdated = false;
    // console.log("###################### BIG DATA - loaded ########################");
    // console.log(currentBigData);

    if (this.props.mainState.billingData &&
        this.props.mainState.billingData.all &&
        this.props.mainState.billingData.all.length > 0) {
      this.props.mainState.billingData.all.map(currentData => {
        if (!(currentBigData.date_month in currentBigData)) {
          currentBigData[currentData.date_month] = {
          };
        }
        if (!("income" in currentBigData[currentData.date_month])) {
          currentBigData[currentData.date_month].income = currentData.total_billed/100;
          bigDataUpdated = true;
        }
      });
    }

    if (this.props.mainState.billingData && 
        this.props.mainState.billingData.returns &&
        this.props.mainState.billingData.returns.length > 0) {
          this.props.mainState.billingData.returns.map(currentData => {
            if (!(currentData.date_month in currentBigData)) {
              currentBigData[currentData.date_month] = {
              };
            }
            if (!("returns" in currentBigData[currentData.date_month])) {
              currentBigData[currentData.date_month].returns = (-1) * parseFloat(currentData.total_billed/100);
              bigDataUpdated = true;
            }
      });
    }
    // if (this.props.mainState.billingData &&
    //     this.props.mainState.billingData.paidBills &&
    //     Object.keys(this.props.mainState.billingData.paidBills).length > 0) {
    //       Object.keys(this.props.mainState.billingData.paidBills).map(currentKey => {
    //         let currentType = this.props.mainState.billingData.paidBills[currentKey];
    //         currentType.map(currentData => {
    //           if (!(currentData.date_month in currentBigData)) {
    //             currentBigData[currentData.date_month] = {};
    //           }
    //           let localKey = "outcome_" + currentKey;
    //           if (!(localKey in currentBigData[currentData.date_month])) {
    //             currentBigData[currentData.date_month][localKey] =
    //               (-1) * parseFloat(currentData.total_billed) * 1.21;
    //             bigDataUpdated = true;
    //           }
    //         });
    //       });
    // }
    if (this.props.mainState.billingData) {
      // console.log("################# test outcome ################");
      // console.log(this.props.mainState.billingData.paidBills);
    }
    if (this.props.mainState.billingData && 
        this.props.mainState.billingData.paidBills &&
        this.props.mainState.billingData.paidBills.all &&
          this.props.mainState.billingData.paidBills.all.length > 0) {
          this.props.mainState.billingData.paidBills.all.map(currentData => {
            if (!(currentData.date_month in currentBigData)) {
              currentBigData[currentData.date_month] = {
              };
            }
            if (!("outcome" in currentBigData[currentData.date_month])) {
              currentBigData[currentData.date_month].outcome = (-1) * parseFloat(currentData.total_billed * 1.21);
              bigDataUpdated = true;
            }
      });
    }

    if (this.props.mainState.payrolls 
        && this.props.mainState.payrolls.monthly 
        && this.props.mainState.payrolls.monthly.length > 0) {
      this.props.mainState.payrolls.monthly.map(currentData => {
        if (!(currentData.date_month in currentBigData)) {
          currentBigData[currentData.date_month] = {};
        }
        if (!("payrolls" in currentBigData[currentData.date_month])) {
          currentBigData[currentData.date_month].payrolls =
            -1 * parseFloat(currentData.company_cost);
          bigDataUpdated = true;
        }
      });
    }
    if (JSON.stringify(currentBigData) !== JSON.stringify(this.state.billingBigData)) {
      // console.log("###################### GUARDANDO BIG DATA ########################");
      // console.log(currentBigData);
      this.setState({ billingBigData: currentBigData });
    }
    // console.log("###################### BIG DATA ########################");
    // console.log(currentBigData);
  }
  getDataStyle(key, canvas) {
    let style = {
      backgroundColor: "#000",
      label: "default"
    };
    switch (key) {
      case "plans":
        style.backgroundColor = "#03B78B";
        style.label = "Tarifas";
        break;
      case "extras":
        style.backgroundColor = "#6288C7";
        style.label = "Gastos extra";
        break;
      case "nadupack":
        style.backgroundColor = "#EB4D4B";
        style.label = "Descuentos naduPack";
        break;    
      case "employeePayrolls":
        style.backgroundColor = "#EB4D4B";
        style.label = "Nóminas";
        break;  
      case "returns":
        style.backgroundColor = "#EB4D4B";
        style.label = "Devoluciones";
        break;   
      case "returnsPaid":
        style.backgroundColor = "#03B78B";
        style.label = "Pagadas";
        break;   
      case "all":
        style.backgroundColor = "#F1C40F";
        style.label = "Total";
        break;   
      case "customers_returning":
        style.backgroundColor = "#EB4D4B";
        style.label = "Morosos";
        break; 
      case "customers_returningPaid":
        style.backgroundColor = "#03B78B";
        style.label = "Morosos que pagan";
        break; 
      case "customers_growth":
        style.backgroundColor = "#00cec9";
        style.label = "Clientes nuevos";
        break;
      case "paidBills_variable":
        style.backgroundColor = "#6288C7";
        style.label = "Variables";
        break;
      case "paidBills_recurrent":
        style.backgroundColor = "#F1C40F";
        style.label = "Recurrentes";
        break;
      case "paidBills_investment":
        style.backgroundColor = "#03B78B";
        style.label = "Inversión";
        break;
      case "bigData":
        style.backgroundColor = "#6288C7";
        style.label = "Balance";
        break;
      case "customers_all":
        style = {
          label: "Clientes",
          borderColor: "#18ce0f",
          pointBorderColor: "#FFF",
          pointBackgroundColor: "#18ce0f",
          pointBorderWidth: 2,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 1,
          pointRadius: 4,
          fill: true,
          backgroundColor: this.buildLineGradient("rgba(128, 182, 244, 0)", "#18ce0f", canvas),
          borderWidth: 2
        }
        break;
      case "investment":
        style.backgroundColor = "#03B78B";
        style.label = "Inversión";
        break;
      default:
        style.backgroundColor = getRandomColor();
        style.label = key.replace("paidBills_", "");
        break;
    }
    return style;
  }
  buildLineGradient(startColor, endColor, canvas) {
    let result;

    let ctx = canvas.getContext("2d");
    let gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, endColor);
    gradientStroke.addColorStop(1, "#FFFFFF");
    let gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
    gradientFill.addColorStop(0, startColor);
    gradientFill.addColorStop(1, hexToRGB(endColor, 0.4));

    result = gradientFill;

    return result;
  }
  getMonthName(date) {
    let result = "";
    let dateArray = date.split("/");
    let month = parseInt(dateArray[0]) - 1;
    let year = dateArray[1];
    let months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

    result = months[month] + " " + year;
    
    return result;
  }
  prepareDataForBillingChart(data) {
    // console.log("############# PREPARANDO DATOS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    Object.keys(data).map(currentKey => {
      if (currentKey === "returns" || currentKey === "returnsPaid" || currentKey === "paidBills") return;
      let localData = data[currentKey];
      let dataStyle = this.getDataStyle(currentKey);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.total_billed)/100);
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  prepareDataForBillingReturnsChart(data) {
    // console.log("############# PREPARANDO DATOS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    Object.keys(data).map(currentKey => {
      // console.log("############# currentKey ##############");
      // console.log(currentKey);
      if (currentKey !== "returns" && currentKey !== "returnsPaid") return;
      let localData = data[currentKey];
      let dataStyle = this.getDataStyle(currentKey);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.total_billed)/100);
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  prepareDataForCustomersChart(data, canvas, currentKey) {
    // console.log("############# PREPARANDO DATOS - CUSTOMERS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    // Object.keys(data).map(currentKey => {
      let localData = data; //data[currentKey];
      let dataStyle = this.getDataStyle("customers_" + currentKey, canvas /*currentKey*/);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      localData = localData.slice(1, localData.length);

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.count));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    // });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS - CUSTOMERS ##############");
    // console.log(result);
    //    data: canvas => this.prepareDataForBillingChart(data, canvas),    

    return result;
  }
  prepareDataForCustomersGrowthChart(data) {
    // console.log("############# PREPARANDO DATOS - CUSTOMERS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    // Object.keys(data).map(currentKey => {
      let localData = data; //data[currentKey];
      let dataStyle = this.getDataStyle("customers_growth" /*currentKey*/);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      // localData = localData.slice(1, localData.length);

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      let previousData = null;
      let isFirst = true;
      localData.map(currentData => {
        if (isFirst) {
          previousData = currentData;
          isFirst = false;
          return;
        }
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.count - previousData.count));
        previousData = currentData;
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    // });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS - CUSTOMERS ##############");
    // console.log(result);
    //    data: canvas => this.prepareDataForBillingChart(data, canvas),    

    return result;
  }
  prepareDataForCustomersGrowthLastMonth(data) {
    let localData = data;

    localData = localData.sort(function(a, b) {
      return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    });

    let growth = parseInt(localData[localData.length - 1].count) - parseInt(localData[localData.length - 2].count);
    let growthSign = growth > 0 ? "+" : "";
    let growthColor = growth > 0 ? "#00BA89" : "#c0392b";
    let growthText = growthSign + formatterNumber.format(growth);
    let growthStyle = growth > 0 ? this.getSummupSpanStyle("growth-positive") : this.getSummupSpanStyle("growth-negative");
    // return <span style={{ color: growthColor }}>{growthText.toString()}</span>;    
    return (
      <b><span style={growthStyle}>
        <i className="now-ui-icons users_single-02" />{growthText.toString()}
      </span></b>
    );
  }
  prepareDataForActiveCustomersLastMonth(data) {
    let localData = data;

    localData = localData.sort(function(a, b) {
      return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    });
    
    return formatterNumber.format(parseInt(localData[localData.length - 1].count));
  }
  prepareDataForCurrentInternetCustomers(data) {
    let localData = data;

    // localData = localData.sort(function(a, b) {
    //   return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    // });

    return formatterNumber.format(parseInt(localData));
  }
  prepareDataForCurrentMobileLines(data) {
    let localData = data;

    // localData = localData.sort(function(a, b) {
    //   return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    // });

    return formatterNumber.format(parseInt(localData));
  }
  prepareDataForCurrentMobileCustomers(data) {
    let localData = data;

    // localData = localData.sort(function(a, b) {
    //   return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    // });

    return formatterNumber.format(parseInt(localData));
  }
  getSummupSpanStyle(key) {
    let result = {
      // backgroundColor: "#F00",
      // borderRadius: "2px",
      // padding: "4px 8px",
      // boxShadow: "0px 0px 2px rgba(0,0,0,0.3)",
      whiteSpace: "nowrap",
      color: "#9A9A9A"
    };
    //F09300
    // return result;

    switch (key) {
      case "growth-positive":
        result.color = "#03B78C";
        break;
      case "growth-negative":
        result.color = "#EB4D4B";
        break;
      case "internet":
        result.color = "#6288C7";
        // result.color = "#FFF";
        break;
      case "internet-mobile":
        result.color = "#D63031";
        break;
      case "mobile":
        result.color = "#F0932B";
        break;
      case "internet_wifi":
        result.color = "#F09300";
        // result.color = "#FFF";
        break;
      case "internet_fiber":
        result.color = "#E4C441";
        // result.color = "#FFF";
        break;
      case "ARPU":
        result.color = "#9A9A9A";
        // result.color = "#FFF";
        break;
      case "billing_prediction":
        result.color = "#03B78C";
        // result.color = "#FFF";
        break;
      default:
        break;
    }

    return result;
  }
  prepareDataForCustomersDistribution(data) {
    let only_mobile = this.props.mainState.overallStatus.mobile_customers_without_internet;
    let mobile_internet = this.props.mainState.overallStatus.mobile_customers_with_internet;
    let internet = this.props.mainState.overallStatus.internet;
    let only_internet = parseInt(internet) - parseInt(mobile_internet);

    let result = null;

    result = (
      <Row>
        <Col {...colSizesCustomersSummup}>
          {this.buildCustomersGrowthLastMonth()}
        </Col>
        <Col {...colSizesCustomersSummup}>
          <b><span style={this.getSummupSpanStyle("internet")}>
            <i className="now-ui-icons location_world" /> {formatterNumber.format(parseInt(only_internet))}
          </span></b>
        </Col>
        <Col {...colSizesCustomersSummup}>
          <b><span style={this.getSummupSpanStyle("internet-mobile")}>
            <i className="now-ui-icons shopping_box" /> {formatterNumber.format(parseInt(mobile_internet))}
          </span></b>
        </Col>
        <Col {...colSizesCustomersSummup}>
          <b><span style={this.getSummupSpanStyle("mobile")}>
            <i className="now-ui-icons tech_mobile" /> {formatterNumber.format(parseInt(only_mobile))}
          </span></b>
        </Col>
      </Row>
    );

    // localData = localData.sort(function(a, b) {
    //   return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    // });

    return result;
  }
  prepareDataForCustomersInternetDistribution(data) {
    let wifi = this.props.mainState.overallStatus.internet_wifi;
    let fiber = this.props.mainState.overallStatus.internet_fiber;

    let result = null;

    result = (
      <Row>
        <Col {...colSizesCustomersInternetSummup}>
          <b><span style={this.getSummupSpanStyle("internet_wifi")}>
            <i className="now-ui-icons media-2_sound-wave" /> {formatterNumber.format(parseInt(wifi))}
          </span></b>
        </Col>
        <Col {...colSizesCustomersInternetSummup}>
          <b><span style={this.getSummupSpanStyle("internet_fiber")}>
            <i className="now-ui-icons education_atom" /> {formatterNumber.format(parseInt(fiber))}
          </span></b>
        </Col>
      </Row>
    );

    // localData = localData.sort(function(a, b) {
    //   return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    // });

    return result;
  }
  prepareDataForReturningCustomersChart(data) {
    // console.log("############# PREPARANDO DATOS - RETURNING CUSTOMERS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    Object.keys(data).map(currentKey => {
      if (currentKey === "all") return;
      let localData = data[currentKey];
      let dataStyle = this.getDataStyle("customers_" + currentKey);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.count));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS - CUSTOMERS ##############");
    // console.log(result);
    //    data: canvas => this.prepareDataForBillingChart(data, canvas),    

    return result;
  }
  prepareDataForPaidBillsChart(data) {
    // console.log("############# PREPARANDO DATOS ##############");
    // console.log(data);
    // // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: [] };
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    Object.keys(data).map(currentKey => {
      // let currentKey = "paidBills";
      // console.log("############# currentKey ##############");
      // console.log(currentKey);
      if (currentKey === "all") return;
      let localData = data[currentKey];
      let dataStyle = this.getDataStyle("paidBills_" + currentKey);

      try {
        localData = localData.sort(function(a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
        });
      } catch (e) {
        return;
      }

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.total_billed*1.21));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  prepareDataForBillsBigDataChart(data) {
    // console.log("############# PREPARANDO DATOS BIG DATA ##############");
    // console.log(Object.keys(this.state.billingBigData).toString());
    // console.log("############# PRUEBA BIG DATA ##############");
    // console.log(Object.keys(this.state.billingBigData["07/2020"]).toString());
    // data = data.plans;

    let result = { labels: [], datasets: [] };
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;
    let _data = [];

    Object.keys(data).map(key => {
      let value = data[key];
      let currentMonth = {
        date_month: key
      };
      let summon = 0;
      // console.log("############# PREPARANDO DATOS BIG DATA - conceptos ##############");
      // console.log(Object.keys(data[key]).toString());
      Object.keys(value).map(currentKey => {
        let currentValue = value[currentKey];
        // console.log("############# PREPARANDO DATOS BIG DATA - (" + currentKey + " - " + key + ") ##############");
        // console.log(currentValue);
        summon += currentValue;
        // console.log("############# PREPARANDO DATOS BIG DATA - summon ##############");
        // console.log(summon);
      });
      currentMonth.total_billed = summon;
      _data.push(currentMonth);
    });
    data = _data;
    // Object.keys(data).map(currentKey => {
    let currentKey = "bigData";
    // if (currentKey !== "returns" && currentKey !== "returnsPaid") return;
    let localData = data; //data[currentKey];
    let dataStyle = this.getDataStyle(currentKey);

    localData = localData.sort(function(a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
    });

    let newDataset = {
      ...dataStyle,
      data: []
    };
    let newData = [];

    localData.map(currentData => {
      if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
      newData.push(parseInt(currentData.total_billed));
    });
    labelsLoaded = true;
    newDataset.data = newData;

    datasets.push(newDataset);
    // });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  prepareDataForEmployeesPayrollsChart(data) {
    // console.log("############# PREPARANDO DATOS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    // Object.keys(data).map(currentKey => {
      let currentKey = "employeePayrolls";
      // console.log("############# currentKey ##############");
      // console.log(currentKey);
      // if (currentKey !== "returns" && currentKey !== "returnsPaid") return;
      let localData = data; //data[currentKey];
      let dataStyle = this.getDataStyle(currentKey);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.company_cost));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    // });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  prepareDataForPaidBillsByConceptChart(data) {
    // console.log("############# PREPARANDO DATOS - DETAILED PAID BILLS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    Object.keys(data).map(currentKey => {
      if (currentKey === "investment") return;
      let localData = Object.values(data[currentKey]);
      let dataStyle = this.getDataStyle("paidBills_" + currentKey);

      try {
        localData = localData.sort(function(a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
        });
      } catch (e) {
        console.error("############# PREPARANDO DATOS - DETAILED PAID BILLS - ERROR ORDENANDO ##############");
        console.error(e);
      }

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.total_billed));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS - CUSTOMERS ##############");
    // console.log(result);
    //    data: canvas => this.prepareDataForBillingChart(data, canvas),    

    return result;
  }
  prepareDataForPaidBillsInvestmentChart(data) {
    // console.log("############# PREPARANDO DATOS ##############");
    // console.log(data);
    // data = data.plans;
    // console.log("############# DATOS ELEGIDOS ##############");
    // console.log(data);

    let result = { labels: [], datasets: []};
    let labels = [];
    let datasets = [];
    let labelsLoaded = false;

    // Object.keys(data).map(currentKey => {
      let currentKey = "investment";
      // console.log("############# currentKey ##############");
      // console.log(currentKey);
      // if (currentKey !== "returns" && currentKey !== "returnsPaid") return;
      let localData = data; //data[currentKey];
      let dataStyle = this.getDataStyle(currentKey);

      localData = localData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });

      let newDataset = {
        ...dataStyle,
        data: []
      };
      let newData = [];
  
      localData.map(currentData => {
        if (!labelsLoaded) labels.push(this.getMonthName(currentData.date_month));
        newData.push(parseInt(currentData.total_billed));
      });
      labelsLoaded = true;
      newDataset.data = newData;
  
      datasets.push(newDataset);
    // });

    result = {
      labels: labels,
      datasets: datasets
    };
    // console.log("############# DATOS PREPARADOS ##############");
    // console.log(result);

    return result;
  }
  getBillingSummup() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.all && this.props.mainState.billingData.all.length > 0) {
      let data = this.props.mainState.billingData.all;
      if (data) {
        let localData = data;
        let total_billed = 0.0;
  
        localData = localData.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
        });
    
        localData.map(currentData => {
          total_billed += parseInt(currentData.total_billed) / 100;
        });
    
        result = formatterCurrency.format(total_billed);
        result = "(" + localData[0].date_month + " <> " + localData[localData.length - 1].date_month + ") " + result;
        // console.log("############# DATOS PREPARADOS ##############");
        // console.log(result);
    
        return result;
      }
    } else {
      result = " Cargando...";
    }
    return result;
  }
  buildGroupedBillingChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.plans && this.props.mainState.billingData.plans.length > 0) {
      let data = this.props.mainState.billingData;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        data = {
          data: this.prepareDataForBillingChart(data),          
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: true
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: true
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildActiveCustomersChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && this.props.mainState.monthlyCustomers.all && this.props.mainState.monthlyCustomers.all.length > 0) {
      let data = this.props.mainState.monthlyCustomers.all;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        let localData = data;
        data = {
          data: canvas => this.prepareDataForCustomersChart(localData, canvas, "all"),          
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: true
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: true
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Line
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildCustomersGrowthChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && this.props.mainState.monthlyCustomers.all && this.props.mainState.monthlyCustomers.all.length > 0) {
      let data = this.props.mainState.monthlyCustomers.all;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        let localData = data;
        data = {
          data: this.prepareDataForCustomersGrowthChart(localData),
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: true
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: true
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildBillingReturnsChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.plans && this.props.mainState.billingData.plans.length > 0) {
      let data = this.props.mainState.billingData;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        data = {
          data: this.prepareDataForBillingReturnsChart(data),          
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildBillReturningCustomersChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && this.props.mainState.monthlyCustomers.returning && this.props.mainState.monthlyCustomers.returning.length > 0) {
      let data = this.props.mainState.monthlyCustomers;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        let localData = data;
        data = {
          data: this.prepareDataForReturningCustomersChart(localData),             
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildPaidBillsChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.paidBills && Object.keys(this.props.mainState.billingData.paidBills).length > 0) {
      let data = this.props.mainState.billingData.paidBills;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        data = {
          data: this.prepareDataForPaidBillsChart(data),
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: true
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: true
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildBillsBigDataChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - BIG DATA ##############");
    // console.log(this.props);
    if (Object.keys(this.state.billingBigData).length > 0) {
      let data = this.state.billingBigData;
      if (data) {
        // console.log("############# RENDERIZANDO CHART - BIG DATA ##############");
        // console.log(data);
        // result = MyResponsiveBar(dataTest);
        data = {
          data: this.prepareDataForBillsBigDataChart(data),
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildEmployeesPayrollsChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.payrolls && this.props.mainState.payrolls.monthly && this.props.mainState.payrolls.monthly.length > 0) {
      let data = this.props.mainState.payrolls.monthly;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        data = {
          data: this.prepareDataForEmployeesPayrollsChart(data),          
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildPaidBillsByConceptChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.paidBills && this.props.mainState.billingData.paidBills.detail && Object.keys(this.props.mainState.billingData.paidBills.detail).length > 0) {
      let data = this.props.mainState.billingData.paidBills.detail;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        let localData = data;
        data = {
          data: this.prepareDataForPaidBillsByConceptChart(localData),             
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildPaidBillsInvestmentChart() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.paidBills && this.props.mainState.billingData.paidBills.investment && this.props.mainState.billingData.paidBills.investment.length > 0) {
      let data = this.props.mainState.billingData.paidBills.investment;
      if (data) {
        // result = MyResponsiveBar(dataTest);
        let localData = data;
        data = {
          data: this.prepareDataForPaidBillsInvestmentChart(localData),             
          options: {
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10
            },
            responsive: 1,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawBorder: false
                  },
                  stacked: false
                }
              ],
              xAxes: [
                {
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    zeroLineColor: "transparent",
                    drawTicks: false,
                    drawBorder: false
                  },
                  stacked: false
                }
              ]
            },
            layout: {
              padding: { left: 0, right: 0, top: 15, bottom: 15 }
            }
          }
        };
        result = 
          <Bar
            data={data.data}
            options={data.options}
          />;
      }
    } else {
      result = 
        <Line
          data={chartsLine1.data}
          options={chartsLine1.options}
        />;
    }
    return result;
  }
  buildLastBilling() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.all && this.props.mainState.billingData.all.length > 0) {
      let data = this.props.mainState.billingData.all;

      data = data.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      result = <h2 className="h-nomargin">{formatterCurrency.format((data[data.length - 1].total_billed)/100)}</h2>;
    } else {
      result = 
        "Cargando datos..."
    }
    return result;
  }
  buildCustomersGrowthLastMonth() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && this.props.mainState.monthlyCustomers.all && this.props.mainState.monthlyCustomers.all.length > 0) {
      let data = this.props.mainState.monthlyCustomers.all;
      let result = this.prepareDataForCustomersGrowthLastMonth(data);
      // console.log("######### TEST GROWTH LAST MONTH ###########");
      // console.log(result);
      return result;
    } else {
      result = 
        <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />;
    }
    return result;
  }
  buildActiveCustomersLastMonth() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && this.props.mainState.monthlyCustomers.all && this.props.mainState.monthlyCustomers.all.length > 0) {
      let data = this.props.mainState.monthlyCustomers.all;
      return <h2 className="h-nomargin">{this.prepareDataForActiveCustomersLastMonth(data)}</h2>;
    } else {
      result = 
        "Cargando datos...";
    }
    return result;
  }
  buildInternetCustomers() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.overallStatus && this.props.mainState.overallStatus.internet) {
      let data = this.props.mainState.overallStatus.internet;
      return <h2 className="h-nomargin">{this.prepareDataForCurrentInternetCustomers(data)}</h2>;
    } else {
      result = 
        "Cargando datos...";
    }
    return result;
  }
  buildMobileLines() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.overallStatus && this.props.mainState.overallStatus.mobile_lines) {
      let data = this.props.mainState.overallStatus.mobile_lines;
      return <h2 className="h-nomargin">{this.prepareDataForCurrentMobileLines(data)}</h2>;
    } else {
      result = 
        "Cargando datos...";
    }
    return result;
  }
  buildMobileCustomers() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.overallStatus && this.props.mainState.overallStatus.mobile_customers) {
      let data = this.props.mainState.overallStatus.mobile_customers;
      return this.prepareDataForCurrentMobileCustomers(data) + " clientes";
    } else {
      result = 
        "Cargando datos...";
    }
    return result;
  }
  buildCustomersDistribution() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.overallStatus && 
        this.props.mainState.overallStatus.mobile_customers_without_internet &&
        this.props.mainState.overallStatus.mobile_customers_with_internet &&
        this.props.mainState.overallStatus.internet) {
      let data = this.props.mainState.overallStatus;
      result = this.prepareDataForCustomersDistribution(data);
    } else {
      result = (
        <Row>
          <Col {...colSizesCustomersSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
          <Col {...colSizesCustomersSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
          <Col {...colSizesCustomersSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
          <Col {...colSizesCustomersSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
        </Row>
      );
    }
    return result;
  }
  getARPU() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.monthlyCustomers && 
        this.props.mainState.monthlyCustomers.all && 
        this.props.mainState.monthlyCustomers.all.length > 0 &&
        this.props.mainState.billingData && 
        this.props.mainState.billingData.all && 
        this.props.mainState.billingData.all.length > 0) {
      let activeCustomers = this.props.mainState.monthlyCustomers.all;
      activeCustomers = activeCustomers.sort(function(a, b) {
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });      
      // return formatterNumber.format(parseInt(activeCustomers[activeCustomers.length - 1].count));
      activeCustomers = parseInt(activeCustomers[activeCustomers.length - 1].count);

      let last_billing = this.props.mainState.billingData.all;
      last_billing = last_billing.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      last_billing = (last_billing[last_billing.length - 1].total_billed)/100;

      let ARPU = "ARPU " + formatterCurrency.format(last_billing / activeCustomers);
      result = ARPU;
    } else {
      result = 
        "Calculando ARPU...";
    }
    return result;
  }
  buildCustomersInternetDistribution() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART - CUSTOMERS ##############");
    // console.log(this.props);
    if (this.props.mainState.overallStatus && 
        this.props.mainState.overallStatus.internet_fiber &&
        this.props.mainState.overallStatus.internet_wifi) {
      let data = this.props.mainState.overallStatus;
      result = this.prepareDataForCustomersInternetDistribution(data);
    } else {
      result = (
        <Row>
          <Col {...colSizesCustomersInternetSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
          <Col {...colSizesCustomersInternetSummup}>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </Col>
        </Row>
      );
    }
    return result;
  }
  predictNextMonthBilling() {
    let result = null;
    // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.all && this.props.mainState.billingData.all.length > 0) {
      let data = this.props.mainState.billingData.all;

      data = data.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - DATA ##############");
      // console.log(data);

      let growthRates_raw = [];
      let growthRates = [];
      for (let i = 0; i < data.length; i++) {
        if (i >= 0 && i + 1 <= data.length - 1) {
          growthRates.push(parseFloat(parseInt(data[i + 1].total_billed)/parseInt(data[i].total_billed)));
        }
      }
      growthRates_raw = growthRates;

      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - growthRates ##############");
      // console.log(growthRates);

      let summonRates = 0;
      growthRates.map(currentRate => {
        summonRates += currentRate;
      });
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - summonRates ##############");
      // console.log(summonRates);

      let meanRate = parseFloat(summonRates / growthRates.length);
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - meanRate ##############");
      // console.log(meanRate);

      // A seguir
      let growthThreshold = 0.2;
      growthRates = [];
      growthRates_raw.map(currentGrowthRate => {
        let relativeGrowthRatio = Math.abs(1 - currentGrowthRate / meanRate);
        // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - relativeGrowthRatio ##############");
        // console.log(relativeGrowthRatio);
        if (relativeGrowthRatio < growthThreshold) growthRates.push(currentGrowthRate);
      });
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - growthRates 2 ##############");
      // console.log(growthRates);
      summonRates = 0;
      growthRates.map(currentRate => {
        summonRates += currentRate;
      });
      meanRate = parseFloat(summonRates / growthRates.length);
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - meanRate 2 ##############");
      // console.log(meanRate);
      // A seguir

      let prediction = parseInt(data[1].total_billed) * (1 + data.length * (meanRate - 1)) / 100;
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - prediction without format ##############");
      // console.log(prediction);
      prediction = formatterCurrency.format(prediction);
      // console.log("############# CALCULANDO PREDICCIÓN DE FACTURACIÓN - prediction ##############");
      // console.log(prediction);

      // result = <h2 className="h-nomargin">{formatterCurrency.format((data[data.length - 1].total_billed)/100)}</h2>;
      result = (
        <Row>
          <Col {...colSizesCustomersInternetSummup}>
            <b><span style={this.getSummupSpanStyle("ARPU")}>
              <i className="now-ui-icons shopping_cart-simple" /> {this.getARPU()}
            </span></b>
          </Col>
          <Col {...colSizesCustomersInternetSummup}>
            <b><span style={this.getSummupSpanStyle("billing_prediction")}>
              <i className="now-ui-icons business_chart-bar-32" /> {"Next " + prediction}
            </span></b>
          </Col>
        </Row>
      );
    } else {
      result = 
      <Col xs={12} className="text-center">
        <span style={this.getSummupSpanStyle("ARPU")}>        
          <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" /> Calculando...
        </span>
      </Col>
    }
    return result;
  }
  getLastMonthBilling() {
    let result = null;
    // console.log("############# RENDERIZANDO CHART ##############");
    // console.log(this.props);
    if (this.props.mainState.billingData && this.props.mainState.billingData.all && this.props.mainState.billingData.all.length > 0) {
      let data = this.props.mainState.billingData.all;

      data = data.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date("01/" + a.date_month) - new Date("01/" + b.date_month);
      });
      result = data[data.length - 1].date_month;
    } else {
      result = 
        "Cargando datos..."
    }
    return result;
  }
  render() {
    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">Pegasus</h2>
              <p className="category">
                El ojo que todo lo ve
              </p>
            </div>
          }
        />
        <div className="content">
          <br />
          <br />
          <Row>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>
                    Facturación del último mes ({this.getLastMonthBilling()})
                  </CardCategory>
                  <CardTitle tag="h4"><i className="now-ui-icons business_money-coins" /> Facturación</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody className="text-center">
                  {this.buildLastBilling()}
                </CardBody>
                <CardFooter>
                  {this.predictNextMonthBilling()}
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Clientes activos este mes</CardCategory>
                  <CardTitle tag="h4"><i className="now-ui-icons users_single-02" /> Clientes</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody className="text-center">
                  {this.buildActiveCustomersLastMonth()}
                </CardBody>
                <CardFooter className="text-left">
                  {this.buildCustomersDistribution()}
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Clientes con Internet en casa</CardCategory>
                  <CardTitle tag="h4"><i className="now-ui-icons location_world" /> Internet</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody className="text-center">
                  {this.buildInternetCustomers()}
                </CardBody>
                <CardFooter className="text-left">
                  {this.buildCustomersInternetDistribution()}
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Móviles activos</CardCategory>
                  <CardTitle tag="h4"><i className="now-ui-icons tech_mobile" /> Móviles</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody className="text-center">
                  {this.buildMobileLines()}
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons users_single-02",
                        t: this.buildMobileCustomers()
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            <Card className="card-plain text-center">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons business_chart-bar-32" /> Facturación{"  "}
                  <p className="category"> Gráficas de la evolución de la facturación</p>
                </h5>
              </CardHeader>
            </Card>
          </Row>
          <Row>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Resultado mensual</CardCategory>
                  <CardTitle tag="h4">Balance</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildBillsBigDataChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Tarifas / Gastos extra / naduPack / Total</CardCategory>
                  <CardTitle tag="h4">Facturación</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildGroupedBillingChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: this.getBillingSummup()
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Facturas devueltas por los clientes / pagadas</CardCategory>
                  <CardTitle tag="h4">Devoluciones</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildBillingReturnsChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Cantidad de clientes/mes con recibo devuelto</CardCategory>
                  <CardTitle tag="h4">Morosos cabrones</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildBillReturningCustomersChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Facturas pagadas a proveedores</CardCategory>
                  <CardTitle tag="h4">Facturas pagadas</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildPaidBillsChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Gasto mensual en nóminas</CardCategory>
                  <CardTitle tag="h4">Nóminas</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildEmployeesPayrollsChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.medium} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Facturas de inversiones</CardCategory>
                  <CardTitle tag="h4">Inversiones</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildPaidBillsInvestmentChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            <Card className="card-plain text-center">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons business_chart-bar-32" /> Clientes{"  "}
                  <p className="category"> Gráficas de la evolución de los clientes</p>
                </h5>
              </CardHeader>
            </Card>
          </Row>
          <Row>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Evolución de los clientes</CardCategory>
                  <CardTitle tag="h4">Clientes activos</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildActiveCustomersChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Nuevos clientes al mes</CardCategory>
                  <CardTitle tag="h4">Crecimiento clientes</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    {this.buildCustomersGrowthChart()}
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Recién actualizado"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Simple With Grids And Numbers</CardCategory>
                  <CardTitle tag="h4">Bar Chart</CardTitle>
                </CardHeader>
                <CardBody>
                  <Bar data={chartsBar1.data} options={chartsBar1.options} />
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[{ i: "now-ui-icons ui-2_time-alarm", t: "Last 7 days" }]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col {...this.state.chartSizes.small} className="ml-auto">
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Multiple Bars No Gradient</CardCategory>
                  <CardTitle tag="h4">Bar Chart 2</CardTitle>
                </CardHeader>
                <CardBody>
                  <Bar data={chartsBar2.data} options={chartsBar2.options} />
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[{ i: "now-ui-icons ui-2_time-alarm", t: "Last 7 days" }]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

// ##############################
// // // Function that converts a hex color number to a RGB color number
// #############################
function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}
function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default Pegasus;



// WEBPACK FOOTER //
// ./src/views/Pegasus/Pegasus.jsx